<template>
  <div class="v2026-customer-panel">

    <PanelCollapseBarV2026 ariaLabel="ย่อแผงข้อมูลลูกค้า"
                           @toggleCollapse="$emit('toggleCollapse')" />

    <PanelTabBarV2026 :activeTab="activeTab" :labels="tabLabels" @setTab="setTab" />

    <PanelSubTabBarV2026 v-if="showSubTabBar"
                         :items="visibleSubTabs"
                         :activeKey="activeSubKey"
                         @select="goToSubTab" />

    <div class="v2026-cp-scroll" ref="subTabScroll">

    <div class="v2026-cp-tabpane" v-if="activeTab === 1">

    <PanelHeaderV2026 :type="0"
                      :statusIcons="headerStatusIcons"
                      :avatarUrl="avatarUrl"
                      :channelBadge="channelBadge"
                      :displayName="headerName"
                      roleLabel="คุณลูกค้า"
                      :subLink="latestBookingProvince"
                      :convCustomer="convCustomer"
                      :canEdit="!!convCustomer"
                      :conversationId="selectedConversation && selectedConversation.id"
                      :customerType="selectedConversation && selectedConversation.customer_type"
                      :professional="convCustomer && convCustomer.beneat_professional"
                      :beneatUserId="convCustomer && convCustomer.beneat_user_id"
                      :beneatUserHref="headerUserHref"
                      @notify="showToast($event.variant, $event.title, $event.message)" />

    <important-message-v2026 :customer="convCustomer"
      :conversationId="selectedConversation && selectedConversation.id" />

    <UserInfoCardV2026 :type="0"
                       :idValue="userId"
                       :phone="phone"
                       :email="email"
                       :hasEmail="true"
                       :convCustomer="convCustomer"
                       :canEdit="!!convCustomer"
                       :conversationId="selectedConversation && selectedConversation.id"
                       @notify="showToast($event.variant, $event.title, $event.message)" />

    <TagsSectionV2026 :type="0" :selectedConversation="selectedConversation"
                      :tags="tags" :admin="admin"
                      @notify="showToast($event.variant, $event.title, $event.message)" />

    <div class="v2026-cp-system">
      <span class="v2026-cp-section-label">ข้อมูลลูกค้าในระบบ</span>
      <EntityCardV2026 variant="card"
                       :avatarUrl="avatarUrl"
                       :displayName="systemName"
                       idLabel="User ID:"
                       :idValue="userId"
                       :idHref="linkProfileUser(userId)" />
    </div>

    <!-- TODO(wiring): these tiles are still placeholders. -->
    <div class="v2026-cp-stats">
      <!-- A stat with a hint shows it on hover anywhere on the tile; the info glyph only signals it. -->
      <div class="v2026-cp-card v2026-cp-stat" v-for="stat in stats" :key="stat.label"
           v-b-tooltip.hover.top :title="stat.hint || null">
        <div class="v2026-cp-stat__top">
          <span v-if="!['coin'].includes(stat.label.toLowerCase())" class="v2026-cp-mask v2026-cp-stat__ico" aria-hidden="true"
                :style="maskStyle(stat.icon)"></span>
          <img v-else class="v2026-cp-stat__ico" style="border-radius: 50%;" :src="stat.icon" :alt="stat.label">
          <span class="v2026-cp-stat__label" >{{ stat.label }}</span>
          <i v-if="stat.hint" class="fas fa-info-circle v2026-cp-stat__hint" role="img"
             :aria-label="stat.hint"></i>
        </div>
        <div class="v2026-cp-stat__value">{{ stat.value }}</div>
      </div>
    </div>

    <div class="v2026-cp-accounts" v-if="otherAccounts.length">
      <span class="v2026-cp-section-label">Account ที่ใช้เบอร์โทรเดียวกัน</span>
      <div class="v2026-cp-accounts__list">
        <EntityCardV2026 v-for="(acc, index) in otherAccounts" :key="index"
                         variant="row"
                         :avatarUrl="userAvatar(acc.picture)"
                         :displayName="acc.full_name"
                         idLabel="User ID:"
                         :idValue="acc.id"
                         :idHref="linkProfileUser(acc.id)" />
      </div>
    </div>

    </div><!-- /TAB 1 -->

    <div class="v2026-cp-tabpane v2026-cp-notes" v-if="activeTab === 2">

      <SystemNotesV2026 ref="secSystemNotes" :type="0" :entityId="userId" :admin="admin" />

      <ChatNoteV2026 ref="secChatNote" :type="0" :customer="convCustomer"
                     :conversationId="selectedConversation && selectedConversation.id"
                     @notify="showToast($event.variant, $event.title, $event.message)" />

    </div><!-- /TAB 2 -->

    <div class="v2026-cp-tabpane v2026-cp-bookings" v-if="activeTab === 3">

      <!-- Sub-tabs "ตารางคุณลูกค้า" / "ตารางคุณแม่บ้าน" scroll-spy over these two stacked sections, like
           tab 2. The customer section stays first so the maid section's bottom padding ends the pane. -->
      <div v-if="useCustomerScheduleSubTabs" ref="secCustomerSchedule">
        <CustomerScheduleV2026 :userId="userId" />
      </div>

      <div ref="secMaidSchedule" :class="{ 'v2026-cp-schedsec--divided': useCustomerScheduleSubTabs }">
        <schedule-tab-v2026 :type="0"
          :professionals="professionals" :selected-maid="selectedMaid" :schedule-month="scheduleMonth"
          :orders-by-day-map="ordersByDayMap" :selected-schedule-day="selectedScheduleDay"
          :schedule-loading="scheduleLoading" :selected-day-orders="selectedDayOrders"
          :latest-order="latestOrder" :use-calendar-component="useCalendarComponent"
          :icons="icons" :weekdays="weekdays" :calendar-cells="calendarCells" :thai-month-label="thaiMonthLabel"
          @search="onSearchMaid" @select-maid="onSelectMaid" @month-change="onCalMonthChange"
          @select-day="onCalSelectDay" @create="createBooking"
          @prev-month="prevMonth" @next-month="nextMonth" @select-cell="selectScheduleDay" />
      </div>

    </div><!-- /TAB 3 -->

    <div class="v2026-cp-tabpane" v-if="activeTab === 4">
      <AiAssistantTabV2026 :selected-conversation="selectedConversation"
                           empty-text="• ไม่พบข้อมูลการสนทนาของลูกค้า"
                           :showFunctionCalling="canSeeFunctionCalling" />
    </div><!-- /TAB 4 -->

    </div><!-- /v2026-cp-scroll -->

    <BaseToast :open="toast.open" :variant="toast.variant" :title="toast.title" :message="toast.message"
               :icon="toast.icon"
               @close="toast.open = false" />

  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import ScheduleTabV2026 from './ScheduleTabV2026.vue'
import BaseToast from '@/components/coversation/BaseToast.vue'
import ImportantMessageV2026 from '@/components/coversation/ImportantMessageV2026.vue'
import AiAssistantTabV2026 from '@/components/coversation/AiAssistantTabV2026.vue'
import PanelCollapseBarV2026 from '@/components/coversation/PanelCollapseBarV2026.vue'
import PanelTabBarV2026 from '@/components/coversation/PanelTabBarV2026.vue'
import PanelSubTabBarV2026 from '@/components/coversation/PanelSubTabBarV2026.vue'
import panelSubTabs2026 from '@/components/coversation/panelSubTabs2026'
import railFunctionCalling2026 from '@/components/coversation/railFunctionCalling2026'
import SystemNotesV2026 from '@/components/coversation/SystemNotesV2026.vue'
import TagsSectionV2026 from '@/components/coversation/TagsSectionV2026.vue'
import ChatNoteV2026 from '@/components/coversation/ChatNoteV2026.vue'
import PanelHeaderV2026 from '@/components/coversation/PanelHeaderV2026.vue'
import UserInfoCardV2026 from '@/components/coversation/UserInfoCardV2026.vue'
import EntityCardV2026 from '@/components/coversation/EntityCardV2026.vue'
import { resolveStatusIcons } from '@/components/coversation/statusIconCatalog'
import CustomerScheduleV2026 from '@/components/coversation/CustomerScheduleV2026.vue'

// Tab 3 split into "ตารางคุณลูกค้า" + "ตารางคุณแม่บ้าน". false = tab 3 exactly as before (maid schedule only).
const USE_CUSTOMER_SCHEDULE_SUBTABS = true
// The "การจองบริการล่าสุด" card is rendered inside ScheduleTabV2026, so it can't be a $ref here.
const LATEST_ORDER_ANCHOR = 'secLatestOrder'

// One-shot per press: a collapse/expand remount must not jump back to the AI tab.
let appliedVisionToken = null

export default {
  name: 'customer-panel-v2026',
  mixins: [panelSubTabs2026, railFunctionCalling2026],
  components: {
    ScheduleTabV2026,
    BaseToast,
    ImportantMessageV2026,
    AiAssistantTabV2026,
    PanelCollapseBarV2026,
    PanelTabBarV2026,
    PanelSubTabBarV2026,
    SystemNotesV2026,
    TagsSectionV2026,
    ChatNoteV2026,
    PanelHeaderV2026,
    UserInfoCardV2026,
    EntityCardV2026,
    CustomerScheduleV2026
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeTab: 1,
      subTabScrollRef: 'subTabScroll',
      // A tab with no entry gets no strip and no spy work.
      subTabs: Object.assign({
        2: [
          { key: 'sysnote', label: 'โน้ตในระบบ', refs: ['secSystemNotes'] },
          { key: 'chatnote', label: 'โน้ตแชท', refs: ['secChatNote'] }
        ]
      }, USE_CUSTOMER_SCHEDULE_SUBTABS ? {
        3: [
          { key: 'custsched', label: 'ตารางคุณลูกค้า', refs: ['secCustomerSchedule'] },
          { key: 'maidsched', label: 'ตารางคุณแม่บ้าน', refs: ['secMaidSchedule'] },
          // Not a $ref of this panel — resolveSubTabEl finds it inside the maid section.
          { key: 'latestorder', label: 'การจองล่าสุด', refs: [LATEST_ORDER_ANCHOR] }
        ]
      } : {}),
      useCustomerScheduleSubTabs: USE_CUSTOMER_SCHEDULE_SUBTABS,
      tabLabels: {
        tab1: 'ข้อมูลลูกค้า',
        tab2: 'โน้ต',
        tab3: 'บุ๊กมาร์ก',
        tab4: 'ผู้ช่วย AI'
      },
      icons: {
        bookmark: require('@/assets/icons2026/bookmark-03.svg'),
        edit: require('@/assets/icons2026/pencil-edit.svg'),
        chevron: require('@/assets/icons2026/arrow-right.svg'),
        line: require('@/assets/icons2026/line-color.svg'),
        facebook: require('@/assets/icons2026/facebook-color.svg'),
        coin: require('@/assets/icons2026/beneat-coin.svg'),
        point: require('@/assets/icons2026/point.svg'),
        discountCode: require('@/assets/icons2026/discount.svg'),
        booking: require('@/assets/icons2026/booking.svg'),
        review: require('@/assets/icons2026/c-review.svg'),
        rating: require('@/assets/icons2026/c-rating.svg'),
        externalLink: require('@/assets/icons2026/external-link.svg'),
        trash: require('@/assets/icons2026/trash.svg'),
        chevronLeft: require('@/assets/icons2026/chevron-left.svg'),
        chevronRight: require('@/assets/icons2026/chevron-right.svg'),
        clock: require('@/assets/icons2026/clock.svg'),
        bClock: require('@/assets/icons2026/b-time.svg'),
        calendar: require('@/assets/icons2026/calendar.svg'),
        bCalendar: require('@/assets/icons2026/b-calendar.svg'),
        bLocation: require('@/assets/icons2026/b-location.svg'),
        bMapLocation: require('@/assets/icons2026/b-maps-location.svg'),
        createBooking: require('@/assets/icons2026/create-booking.svg')
      },
      weekdays: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
      thaiMonths: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      scheduleMonth: moment().startOf('month'), // viewed month
      useCalendarComponent: true,
      selectedMaid: null, // chosen professional (from searchProfessionals)
      maidOrders: [], // orders for scheduleMonth
      scheduleLoading: false, // orders GET in flight
      selectedScheduleDay: null, // 'YYYY-MM-DD' of the clicked calendar cell
      placeholderAvatar: 'https://beneat.co/static/img/unknown.png',
      toast: { open: false, variant: 'success', title: '', message: '' }
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('tag', ['tags']),
    ...mapState('professional', ['professionals']),
    ...mapState('aiAssistant', ['visionRequest']),
    thaiMonthLabel () {
      return `${this.thaiMonths[this.scheduleMonth.month()]} ${this.scheduleMonth.year()}`
    },
    ordersByDayMap () {
      const map = {}
      this.maidOrders.forEach(o => {
        if (!o.cleaning_date) return
        const key = moment(o.cleaning_date).format('YYYY-MM-DD')
        if (!map[key]) map[key] = []
        map[key].push(o)
      })
      return map
    },
    calendarCells () {
      const start = this.scheduleMonth.clone().startOf('month')
      const daysInMonth = start.daysInMonth()
      const leading = start.day() // 0=Sun … blanks before day 1
      const map = this.ordersByDayMap
      const cells = []
      for (let i = 0; i < leading; i++) {
        cells.push({ blank: true, key: 'blank-' + i })
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = start.clone().date(d).format('YYYY-MM-DD')
        cells.push({ blank: false, key: dateStr, day: d, dateStr, count: (map[dateStr] || []).length })
      }
      return cells
    },
    selectedDayOrders () {
      if (!this.selectedScheduleDay) return []
      return this.ordersByDayMap[this.selectedScheduleDay] || []
    },
    cust () {
      return (this.customer && this.customer.customer) ? this.customer.customer : null
    },
    convCustomer () {
      return (this.selectedConversation && this.selectedConversation.customer)
        ? this.selectedConversation.customer : null
    },
    // Reuses this panel's OWN linkProfileUser — no second copy of the admin base URL. Guarded on
    // the id so a missing one yields null, never ".../user/undefined".
    headerUserHref () {
      const id = this.convCustomer && this.convCustomer.beneat_user_id
      return id ? this.linkProfileUser(id) : null
    },
    avatarUrl () {
      const social = this.convCustomer && this.convCustomer.profile_picture
      if (social) return social
      const pic = this.cust && this.cust.picture
      if (pic && /^(https?:)?\/\//.test(pic)) return pic
      return this.placeholderAvatar
    },
    // Same icons the chat card puts before the name.
    headerStatusIcons () {
      const ids = this.selectedConversation && this.selectedConversation.status_icons
      return resolveStatusIcons(Array.isArray(ids) ? ids : [])
    },
    headerName () {
      const n = this.convCustomer && this.convCustomer.name
      if (n && String(n).trim()) return n
      return this.systemName
    },
    systemName () {
      return (this.cust && this.cust.full_name) ? this.cust.full_name : '-'
    },
    userId () {
      return this.cust ? this.cust.id : null
    },
    phone () {
      return this.convCustomer ? this.convCustomer.phone : '-'
    },
    // Same source as phone and as the edit-contact modal's v-model (legacy CustomerInformation.vue
    // also shows selectedConversation.customer.email) — not the system user's cust.email.
    email () {
      return this.convCustomer ? this.convCustomer.email : null
    },
    latestBookingProvince () {
      const province = this.cust && this.cust.latest_order && this.cust.latest_order.province
        ? this.cust.latest_order.province.name_th : null
      return province || '-'
    },
    latestOrder () {
      return (this.cust && this.cust.latest_order) ? this.cust.latest_order : null
    },
    otherAccounts () {
      return (this.customer && Array.isArray(this.customer.other_accounts))
        ? this.customer.other_accounts : []
    },
    channelBadge () {
      const type = this.selectedConversation ? this.selectedConversation.type : null
      switch (type) {
        case 'LineAtConversation':
        case 'LineProfessionalConversation':
          return { icon: this.icons.line, alt: 'LINE' }
        case 'PublicConversation':
          return { icon: this.icons.facebook, alt: 'Facebook' }
        default:
          return null
      }
    },
    stats () {
      const c = this.cust || {}
      return [
        { label: 'Coin', value: c.total_credits ? parseFloat(c.total_credits) : 0, icon: this.icons.coin },
        { label: 'Point', value: c.total_points ? parseFloat(c.total_points) : 0, icon: this.icons.point },
        { label: 'โค้ดส่วนลด', value: (c.promo_code && c.promo_code.length > 0) ? c.promo_code.length : 0, icon: this.icons.discountCode },
        { label: 'Booking', value: c.beneat_order_qty ? Math.round(c.beneat_order_qty) : 0, icon: this.icons.bookmark },
        {
          label: 'Review',
          value: c.review_qty ? Math.round(c.review_qty) : 0,
          icon: this.icons.review,
          // review_qty = COUNT(tb_professional_rating) over this user's orders (chat-server searchUser).
          hint: 'จำนวนครั้งที่ลูกค้าคนนี้ให้คะแนนแม่บ้าน (นับทุกครั้ง ทั้งที่เขียนและไม่เขียนคอมเมนต์)'
        },
        {
          label: 'Rating',
          value: c.avg_rating ? parseFloat(c.avg_rating).toFixed(1) : 0,
          icon: this.icons.rating,
          // avg_rating = AVG(tb_professional_rating.rating) over this user's orders (chat-server searchUser).
          hint: 'คะแนนเฉลี่ยที่ลูกค้าคนนี้ให้แม่บ้าน จากทุกออเดอร์ที่เคยให้คะแนน (ไม่ใช่คะแนนที่แม่บ้านให้ลูกค้า)'
        }
      ]
    }
  },
  watch: {
    visionRequest () {
      this.applyVisionRequest()
    }
  },
  // A request written before this panel mounted (collapsed column) never fires the watcher.
  mounted () {
    this.applyVisionRequest()
  },
  methods: {
    // Pressing "ให้ AI วิเคราะห์รูป" in the chat lands the admin on the AI tab straight away.
    applyVisionRequest () {
      const request = this.visionRequest
      if (!request || request.token === appliedVisionToken) return
      appliedVisionToken = request.token
      this.activeTab = 4
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    userAvatar (picture) {
      return picture !== null ? picture : 'https://beneat.co/static/img/unknown.png'
    },
    linkProfileUser (userId) {
      return userId !== null ? `https://admin-test.beneat.co/user/${userId}` : null
    },
    setTab (n) {
      this.activeTab = n
    },
    ...mapActions('professional', ['searchProfessionals']),
    async onSearchMaid (search, loading) {
      if (!search || !search.trim()) return
      loading(true)
      try {
        await this.searchProfessionals(search)
      } finally {
        loading(false)
      }
    },
    onSelectMaid (maid) {
      this.selectedMaid = maid
      this.selectedScheduleDay = null
      this.maidOrders = []
      if (maid) this.fetchSchedule()
    },
    async fetchSchedule () {
      if (!this.selectedMaid) return
      this.scheduleLoading = true
      try {
        const month = this.scheduleMonth.format('YYYY-MM')
        const { data } = await axios.get(`/beneat/professionals/${this.selectedMaid.id}/orders`, { params: { month } })
        this.maidOrders = (data && Array.isArray(data.data)) ? data.data : []
      } catch (e) {
        this.maidOrders = []
      } finally {
        this.scheduleLoading = false
      }
    },
    prevMonth () {
      this.scheduleMonth = this.scheduleMonth.clone().subtract(1, 'month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    nextMonth () {
      this.scheduleMonth = this.scheduleMonth.clone().add(1, 'month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    selectScheduleDay (cell) {
      this.selectedScheduleDay = cell.dateStr
    },
    onCalMonthChange (ym) {
      this.scheduleMonth = moment(ym, 'YYYY-MM').startOf('month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    onCalSelectDay (dateStr) {
      this.selectedScheduleDay = dateStr
    },
    createBooking () {
      const params = { auto_fill: 1 }
      if (this.convCustomer && this.convCustomer.id) params.user_id = this.convCustomer.id
      if (this.selectedMaid) params.selected_professional_id = this.selectedMaid.id
      if (this.selectedScheduleDay) params.service_date = this.selectedScheduleDay
      const qs = new URLSearchParams(params).toString()
      let url = `https://admin-test.beneat.co/order/create-multiple?${qs}`
      window.open(url, '_blank')
    },
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    },
    // Overrides the mixin's resolver for the one anchor that lives inside a child component; every
    // other ref still goes through the shared implementation. The card only exists while the
    // customer has a latest order, so the sub-tab hides itself otherwise (mixin presence rule).
    resolveSubTabEl (refName) {
      if (refName !== LATEST_ORDER_ANCHOR) {
        return panelSubTabs2026.methods.resolveSubTabEl.call(this, refName)
      }
      const host = this.$refs.secMaidSchedule
      const el = host && host.querySelector ? host.querySelector('[data-subtab-anchor="latest-order"]') : null
      return (el && el.isConnected) ? el : null
    }
  }
}
</script>

<style scoped>
.v2026-customer-panel {
  --v2026-color-main: #31C1D7;
  --v2026-color-main-soft: #31C1D714;
  --v2026-color-icon-idle: #66696C;

  --v2026-link: #007bff;

  --v2026-surface: #ffffff;
  --v2026-surface-sunken: #F8FAFC;
  --v2026-surface-hover: #e9ecf1;

  --v2026-border: #e4e7ec;
  --v2026-text: #101828;
  --v2026-text-secondary: #667085;
  --v2026-text-muted: #98a2b3;
  --v2026-icon: #475467;

  --v2026-r-card: 12px;
  --v2026-r-box: 14px;
  --v2026-r-tab: 10px;

  --v2026-sp-1: 4px;
  --v2026-sp-2: 8px;
  --v2026-sp-3: 12px;
  --v2026-sp-4: 16px;
  --v2026-sp-5: 20px;
  --v2026-sp-6: 24px;

  --v2026-fs-section: 13px;
  --v2026-fs-body: 14px;
  --v2026-fs-meta: 12px;
  --v2026-fs-name: 16px;

  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
  height: 100%;
  overflow: hidden;
  background: var(--v2026-surface);
  padding: 0;
}

.v2026-cp-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: var(--v2026-sp-6);
}

.v2026-cp-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}

.v2026-cp-section-label {
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}

.v2026-cp-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v2026-cp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
}
.v2026-cp-icon-btn:hover {
  background: var(--v2026-surface-hover);
}
.v2026-cp-icon-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}

.v2026-cp-edit {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

.v2026-cp-link {
  color: var(--v2026-link);
  text-decoration: none;
  font-size: var(--v2026-fs-body);
}
.v2026-cp-link:hover {
  text-decoration: underline;
}
.v2026-cp-link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
  border-radius: 3px;
}

.v2026-cp-tabpane {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
}

.v2026-cp-placeholder {
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: var(--v2026-sp-6);
  color: var(--v2026-text-muted);
  font-size: var(--v2026-fs-body);
}

.v2026-cp-notes {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
}

.v2026-cp-maidpick {
  margin-bottom: var(--v2026-sp-3);
  font-size: var(--v2026-fs-body);
}
.v2026-cp-cal__create {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--v2026-sp-2);
  width: 100%;
  margin-top: var(--v2026-sp-3);
  padding: var(--v2026-sp-3);
  border: 1px solid var(--v2026-color-main);
  border-radius: 8px;
  background: rgba(49, 193, 215, 0.08);
  color: var(--v2026-color-main);
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  cursor: pointer;
}
.v2026-cp-cal__create:hover { background: rgba(49, 193, 215, 0.18); }
.v2026-cp-cal__create-ico {
  width: 18px;
  height: 18px;
  background-color: currentColor;
}

.v2026-cp-lastorder { margin-top: var(--v2026-sp-4); }
.v2026-cp-lastorder__maid {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-3);
  margin-top: var(--v2026-sp-3);
  padding-top: var(--v2026-sp-3);
  border-top: 1px solid var(--v2026-border);
}
.v2026-cp-lastorder__avatar {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.v2026-cp-lastorder__info {
  min-width: 0;
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text);
}
.v2026-cp-lastorder__gen { color: var(--v2026-text-secondary); }
.v2026-cp-lastorder__tel { color: var(--v2026-text-secondary); }
.v2026-cp-lastorder__chat {
  display: block;
  margin-top: var(--v2026-sp-3);
  padding: var(--v2026-sp-2);
  border: 1px solid var(--v2026-color-main);
  border-radius: 8px;
  background: rgba(49, 193, 215, 0.08);
  color: var(--v2026-color-main);
  font-size: var(--v2026-fs-meta);
  font-weight: 600;
  text-align: center;
  text-decoration: none;
}
.v2026-cp-lastorder__chat:hover { background: rgba(49, 193, 215, 0.18); }

.v2026-cp-bookings {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
  gap: var(--v2026-sp-3);
}
/* Separates the maid calendar from the customer one above it, so a click's calendar is obvious. */
.v2026-cp-schedsec--divided {
  margin-top: var(--v2026-sp-3);
  padding-top: var(--v2026-sp-4);
  border-top: 1px solid var(--v2026-border);
}

.v2026-cp-cal {
  padding: var(--v2026-sp-3);
}
.v2026-cp-cal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--v2026-sp-2);
}
.v2026-cp-cal__title {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
}
.v2026-cp-cal__nav {
  width: 18px;
  height: 18px;
  background-color: var(--v2026-icon);
}
.v2026-cp-cal__weekdays,
.v2026-cp-cal__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}
.v2026-cp-cal__weekday {
  text-align: center;
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
  padding: var(--v2026-sp-1) 0;
}
.v2026-cp-cal__cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  transition: background 150ms ease;
}
.v2026-cp-cal__cell--empty {
  cursor: default;
}
.v2026-cp-cal__cell:not(.v2026-cp-cal__cell--empty):hover {
  background: var(--v2026-surface-hover);
}
.v2026-cp-cal__cell:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
.v2026-cp-cal__num {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text);
}

.v2026-cp-cal__cell.is-selected {
  box-shadow: inset 0 0 0 2px var(--v2026-color-main);
}
.v2026-cp-cal__cell.is-selected .v2026-cp-cal__num {
  color: var(--v2026-color-main);
  font-weight: 700;
}

.v2026-cp-cal__dots {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 2px;
}
.v2026-cp-cal__dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
}
.v2026-cp-cal__dot--accent {
  background: var(--v2026-color-main);
}

.v2026-cp-cal__dot--more {
  width: 6px;
  height: 6px;
  background: #1a8ea3;
}
.v2026-cp-cal__dot--danger {
  background: #f04438;
}

.v2026-cp-booking {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
  padding: var(--v2026-sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
}
.v2026-cp-booking__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--v2026-sp-2);
}
.v2026-cp-booking__ids {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--v2026-sp-2);
  min-width: 0;
}
.v2026-cp-booking__id {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
}
.v2026-cp-booking__service {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
}
.v2026-cp-booking__row {
  display: flex;
  align-items: flex-start;
  gap: var(--v2026-sp-2);
}
.v2026-cp-booking__ico {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin-top: 1px;
  background-color: var(--v2026-color-main);
}
.v2026-cp-booking__ico--danger {
  background-color: #f04438;
}
.v2026-cp-booking__text {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-secondary);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-cp-booking__text--danger {
  color: #f04438;
}

.v2026-cp-dot {
  color: var(--v2026-text-muted);
}

.v2026-cp-important {
  padding: 0 var(--v2026-sp-4);
}

.v2026-cp-important .v2026-cp-section-label {
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  color: #66696C;
}
.v2026-cp-important .v2026-cp-section-head .v2026-cp-edit {
  width: 18px;
  height: 18px;
}

.v2026-cp-card {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
}

.v2026-cp-system {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}

.v2026-cp-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}
.v2026-cp-stat {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-1);
  padding: var(--v2026-sp-3);
}
.v2026-cp-stat__top {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
}
.v2026-cp-stat__ico {
  width: 18px;
  height: 18px;
  background-color: var(--v2026-color-main);
}
.v2026-cp-stat__label {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-secondary);
}
.v2026-cp-stat__hint {
  margin-left: auto;
  font-size: 12px;
  color: var(--v2026-text-secondary);
  cursor: help;
}
.v2026-cp-stat__value {
  font-size: 20px;
  font-weight: 700;
  color: var(--v2026-text);
}

.v2026-cp-accounts {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}

.v2026-cp-accounts__list {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
  overflow: hidden;
}

</style>
